import { Button } from '@mui/material';

const buttonSx = {
  width: 'fit-content',
  padding: '2px 8px',
  borderRadius: '6px',
  fontFamily: 'Montserrat, sans-serif',
  textTransform: 'none',
  backgroundColor: 'transparent',
  color: 'var(--secondary-color)',
  border: '1px solid var(--secondary-color)',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderColor: 'var(--secondary-color)',
  },
  '&.Mui-disabled': {
    color: 'var(--light-secondary-color)',
    borderColor: 'var(--light-secondary-color)',
  },
};

type TimeButtonProps = {
  time: string;
  onClick: () => void;
};

const TimeButton: React.FC<TimeButtonProps> = ({ time, onClick }) => {
  return (
    <Button onClick={onClick} variant="outlined" sx={buttonSx}>
      {time}
    </Button>
  );
};

export default TimeButton;
